export default __webpack_public_path__ + "static/media/watches7.989c766b.jfif";